import { memo } from 'react'
import IconMail from "../images/icons/envelope.svg"
import IconPhone from "../images/icons/phone.svg"
import IconFacebook from "../images/icons/facebook.svg"
import IconInstagram from "../images/icons/instagram.svg"

const MMPFooter = memo(function MMPFooter() {
    return (
        <footer>
            <div className="container">
                <div className="card" style={{width: "100%"}}>
                    <div className="card-header">Contact Us</div>
                    <div className="card-body">
                        <div className="row">
                            <div className="card-group">

                                <div className="card">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item">
                                            <a href="mailto:info@myminiprints.co.uk?subject=Website%20Enquiry">
                                                <img
                                                    className="p-1"
                                                    src={IconMail}
                                                    alt="email"
                                                    width="32"
                                                    height="32"
                                                    loading="lazy"
                                                    decoding="async"
                                                />
                                                <small>info@myminiprints.co.uk</small>
                                            </a>
                                        </li>

                                        <li className="list-group-item">
                                            <a href="sms:07771754144">
                                                <img
                                                    className="p-1"
                                                    src={IconPhone}
                                                    alt="phone"
                                                    width="32"
                                                    height="32"
                                                    loading="lazy"
                                                    decoding="async"
                                                />
                                                <small>07771 754144</small>
                                            </a>
                                        </li>

                                        <li className="list-group-item">
                                            <a href="https://www.facebook.com/MyMiniPrintsBabyHandAndFootCastingEssex/?ref=bookmarks" rel="noopener noreferrer" target="_blank">
                                                <img
                                                    className="p-1"
                                                    src={IconFacebook}
                                                    alt="Facebook"
                                                    width="32"
                                                    height="32"
                                                    loading="lazy"
                                                    decoding="async"
                                                />
                                                <small>MyMiniPrintsBabyHandAndFootCastingEssex</small>
                                            </a>
                                        </li>

                                        <li className="list-group-item">
                                            <a href="https://www.instagram.com/myminiprintsbabycasting" rel="noopener noreferrer" target="_blank">
                                                <img
                                                    className="p-1"
                                                    src={IconInstagram}
                                                    alt="Instagram"
                                                    width="32"
                                                    height="32"
                                                    loading="lazy"
                                                    decoding="async"
                                                />
                                                <small>@myminiprints - babycasting</small>
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="card">
                                    <div className="card-title">
                                        <p className="fw-bold p-1">Address</p>
                                    </div>
                                    <p className="p-1">
                                        8 Smythe Close<br />
                                        Billericay, Essex<br />
                                        CM11 1SF
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div>
                        <p className="fw-light">
                            <small>
                                Baby Hand And Foot Casting across Essex and surrounding areas:- Basildon, Benfleet, Billericay, Brentwood, Braintree, Brentwood, Canvey Island, Chelmsford, Colchester, Epping, Grays, Great Dunmow, Halstead, Hornchurch, Hockley, Kelvedon, Leigh-on-Sea, Maldon, Rayleigh, Rochford, Romford, Shoeburyness, Stanford-le-Hope, South Woodham Ferrers, Southend, South Ockenden, Thurrock, Upminster, Westcliff-on-Sea, Wickford, Witham.
                            </small>
                        </p>
                    </div>
                </div>
            </div>
            <div>
                <p className="fw-lighter">
                    <small>Copyright &copy; My Mini Prints Baby Hand And Foot Casting Essex 2026</small>
                </p>
            </div>
    </footer>
    )
})

export default MMPFooter
